export default "__VITE_ASSET__2ec73830__"